// Modal.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colour, spacing, media, Heading2 } from './theme';

const ModalBackground = styled.div`
position: fixed;
top: 50%;
left: 50%;
width: 100%;
height: 100vh;
margin: 0;
transform: translate(-50%, -50%);
background: ${colour.palette.white};
overflow: auto;
outline: transparent solid 4px;
padding: ${spacing.spacing5} ${spacing.spacing4};
box-shadow: rgba(26, 26, 26, 0.6) 0 0 2px;
transition: box-shadow 0.1s ease-in-out 0s;
z-index: 1000;
@media ${media.small} {
    height: auto;
    max-height: 95vh;
    max-width: 95vw;
}

@media ${media.medium} {
    padding: ${spacing.spacing7} ${spacing.spacing5};
    max-height: 90vh;
}

@media ${media.large} {
    height: auto;
    max-width: 1200px;
}
`;

export const ModalBody = styled.div`
    margin-top: ${spacing.spacing4};

    p {
        font-size: 22px;
        line-height: 35px;
    }
`;

export const LeadText = styled.p`
    font-size: 1.25rem;
    line-height: 1.6;

    @media ${media.small} {
        font-size: 1.375rem;
    }
`;

export const ModalFooter = styled.div`
    margin-top: ${spacing.spacing8};
`;


const TimeoutComponent = ({ onClose, onCancel, onTimeup, isEng }) => {
  const [time, setTime] = useState(300);
  const [lastUpdate, setLastUpdate] = useState(Date.now());

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const now = Date.now();
        const elapsedSeconds = Math.floor((now - lastUpdate) / 1000);
        if (elapsedSeconds >= time) {
          onCancel();
          return;
        }
        setTime((prevTime) => Math.max(prevTime - elapsedSeconds, 0));

        setLastUpdate(now);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    const interval = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          onTimeup();
          return 0;
        }
        return prevTime - 1;
      });
      setLastUpdate(Date.now());
    }, 1000);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };

  }, [onTimeup]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (minutes == 0 && secs == 0) {
      onTimeup;
    }
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <ModalBackground tabIndex={-1} aria-labelledby='sessoin-timeout-title' aria-describedby='session-timeout-desc' role="alertdialog" aria-modal="true">
      <ModalBody>
        <Heading2 id='sessoin-timeout-title'>
          {isEng ? "Do you need more time? Your session will end soon" : "Avez-vous besoin de plus de temps? Votre session se terminera bientôt."}
        </Heading2>
        <LeadText id='session-timeout-desc' aria-live='assertive'>
          {isEng ? `For security reason your session will end in ${formatTime(time)}.` : `Pour votre sécurité, votre session ${formatTime(time)} dans`}
        </LeadText>
        <LeadText>{isEng ? "Your information will not be saved." : "Nous ne sauvegarderons pas vos informations."}</LeadText>
        <LeadText>{isEng ? `Click "Continue" if you need more time` : "Cliquez sur 'continuer' si vous avez besoin de plus de temps."}</LeadText>
        <ModalFooter>
          <button onClick={onClose} className='ontario-button ontario-button--primary'>{isEng ? 'Continue' : 'Continuer'}</button>
          <button onClick={onCancel} className='ontario-button ontario-button--tertiary'>{isEng ? "Cancel session" : "Annuler la session"}</button>
        </ModalFooter>
      </ModalBody>
    </ModalBackground>
  );
};

export default TimeoutComponent;
